import {
  PhysicianDTO,
  PhysicianDocument,
  DocumentSignatureWorkflowStatuses,
} from 'src/services/apiServices/physician-service/physician-service';
import { PhysicianActions } from './constant';

const {
  REQUEST_GET_ALL_PHYSICIAN_DOCUMENTS,
  GET_ALL_FACILITY_REQUEST,
  GET_ALL_FACILITY_RESET,
  GET_ALL_PATIENT_BY_ENTERPRISE_REQUEST,
  GET_ALL_PATIENT_BY_ENTERPRISE_RESET,
  RESET_GET_ALL_PHYSICIAN_DOCUMENTS,
  LOADING_GET_ALL_PHYSICIAN_DOCUMENTS,
  REQUEST_GET_ALL_COMPLETED_PHYSICIAN_DOCUMENTS,
  RESET_GET_ALL_COMPLETED_PHYSICIAN_DOCUMENTS,
  UPDATE_DOCUMENT_STATUSES_REQUEST,
  UPDATE_DOCUMENT_STATUSES_RESET,
} = PhysicianActions;

export const getAllPhysicianDocumentsAction = (physicianId: string, physicianDto: PhysicianDTO) => {
  return {
    type: REQUEST_GET_ALL_PHYSICIAN_DOCUMENTS,
    physicianId,
    physicianDto,
  };
};

export const getAllPhysicianCompletedDocumentsAction = (
  physicianId: string,
  physicianDto: PhysicianDTO
) => {
  return {
    type: REQUEST_GET_ALL_COMPLETED_PHYSICIAN_DOCUMENTS,
    physicianId,
    physicianDto,
  };
};


export const updateDocumentStatusesAction = (
  physicianId: string,
  physicianDocumentUuids: PhysicianDocument['uuid'][],
  physicianSignatureStatus: DocumentSignatureWorkflowStatuses,
  physicianSignature: string,
  pin?: string,
  consentConfirmation = false
) => {
  return {
    type: UPDATE_DOCUMENT_STATUSES_REQUEST,
    physicianId,
    physicianDocumentUuids,
    physicianSignatureStatus,
    physicianSignature,
    pin,
    consentConfirmation,
  };
};

export const resetPhysicianSignDoc = () => {
  return {
    type: RESET_GET_ALL_PHYSICIAN_DOCUMENTS,
  };
};

export const resetPhysicianSignCompletedDoc = () => {
  return {
    type: RESET_GET_ALL_COMPLETED_PHYSICIAN_DOCUMENTS,
  };
};

export const getFacility = (payload: any) => {
  return {
    type: GET_ALL_FACILITY_REQUEST,
    payload,
  };
};

export const resetGetAllFacility = () => {
  return {
    type: GET_ALL_FACILITY_RESET,
  };
};

export const getAllPatientByEnterprise = (payload: any) => {
  return {
    type: GET_ALL_PATIENT_BY_ENTERPRISE_REQUEST,
    payload,
  };
};

export const resetAllPatientReducer = () => {
  return {
    type: GET_ALL_PATIENT_BY_ENTERPRISE_RESET,
  };
};

export const loadGetAllPhysician = () => {
  return {
    type: LOADING_GET_ALL_PHYSICIAN_DOCUMENTS,
  };
};

export const resetUpdateDocumentStatuses = () => {
  return {
    type: UPDATE_DOCUMENT_STATUSES_RESET,
  };
};
